import "./banners-page.css";
import PageTitle from "../../layouts/PageTitle";
import { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getBannersFunc } from "../../../store/custom-actions/banners/GetBannersSlicer";
import { deleteBannerFunc } from "../../../store/custom-actions/banners/DeleteBannerSlicer";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";
import { useTranslation } from "react-i18next";
import getImageUrl from "../../../utils/getImageUrl";
import Pagination from "../../components/ui/Pagination";
import Table from "../../components/ui/Table";
import SearchBox from "../../components/ui/SearchBox";
import { handleDeleteEntity } from "../../../utils/deleteHelper";

function BannersPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [bannersList, setBannersList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const { loading: getBannersLoading, data: bannersData } = useSelector(
    (state) => state.getBannersSlicer
  );
  const { loading: deleteBannerLoading } = useSelector(
    (state) => state.deleteBannerSlicer
  );

  useEffect(() => {
    dispatch(getBannersFunc());
  }, [dispatch]);

  useEffect(() => {
    bannersData && setBannersList(bannersData);
    bannersData &&
      (jobData.current = bannersData.slice(
        activePag.current * sort,
        (activePag.current + 1) * sort
      ));
    console.log(bannersData);
  }, [bannersData]);

  const filterFunc = () => {
    const api = `?${searchValue !== "" ? `&search=${searchValue}` : ""}`;
    dispatch(getBannersFunc(api));
  };
  const sort = 20;

  const activePag = useRef(0);
  const jobData = useRef(
    bannersList.slice(activePag.current * sort, (activePag.current + 1) * sort)
  );
  const onClick = (i) => {
    activePag.current = i;
    jobData.current = bannersList.slice(
      activePag.current * sort,
      (activePag.current + 1) * sort
    );
  };

  const handleDeleteItem = (id, entityName = "") => {
    handleDeleteEntity({
      id,
      entityName: entityName,
      deleteFunc: deleteBannerFunc,
      dispatch,
      refetchFunc: getBannersFunc,
      t,
    });
  };

  return (
    <>
      <PageTitle
        motherMenu={"Home"}
        activeMenu={"Ui Banners"}
        customClasses={"my-0"}
      />

      <div className="col-12">
        <div className="card">
          <div className="card-header row">
            <div className="col-6">
              <SearchBox
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                onSearch={() => filterFunc()}
              />
            </div>
            <div className="col-6 text-end">
              <Link to="/new-banner" className="btn btn-primary btn-md">
                {"Create"}
              </Link>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive w-100">
              <div id="example_wrapper" className="dataTables_wrapper">
                <Table
                  showIndex={true}
                  startIndex={activePag.current * sort}
                  columns={[
                    { header: t("Title"), render: (row) => row.title },
                    { header: t("Button Text"), render: (row) => row.btn_text },
                    {
                      header: t("Image"),
                      render: (row) => (
                        <img
                          src={getImageUrl(row?.img?.path)}
                          className="img-thumbnail"
                          style={{
                            width: "50px",
                            height: "30px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          alt="img"
                        />
                      ),
                    },
                    {
                      header: t("Mobile image"),
                      render: (row) => (
                        <img
                          src={getImageUrl(row?.mob_img?.path)}
                          className="img-thumbnail"
                          style={{
                            width: "50px",
                            height: "30px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          alt="img"
                        />
                      ),
                    },
                  ]}
                  data={jobData.current}
                  loading={getBannersLoading}
                  actions={(banner) => (
                    <>
                      <Link
                        to={`/update-banner/${banner.id}`}
                        className="btn btn-primary shadow btn-xs sharp me-1"
                      >
                        <i className="fas fa-pencil-alt"></i>
                      </Link>
                      <Link
                        to="#"
                        className="btn btn-danger shadow btn-xs sharp"
                        onClick={() => handleDeleteItem(banner.id, banner.name)}
                      >
                        <i className="fa fa-trash"></i>
                      </Link>
                    </>
                  )}
                />

                <Pagination
                  totalItems={bannersList.length}
                  currentPage={activePag.current}
                  perPage={sort}
                  onPageChange={(page) => onClick(page)}
                  t={t}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <LoadingScreen loading={deleteBannerLoading} />
    </>
  );
}

export default BannersPage;
